import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=04d6c272&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=04d6c272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d6c272",
  null
  
)

export default component.exports